import React from "react";
import { MdCelebration, MdChurch, MdFlare, MdHandshake, MdNotificationsActive, MdOutlineSelfImprovement } from "react-icons/md";

export const POSTERIOR_USERS = [
  { id: "1", name: "Jorge de la Garza", role: "Actividad", avatar: "https://i.pravatar.cc/300?u=iu", desempeño: 1, tarde: 0, temprano: 0, preceptorias: 2 },
  { id: "2", name: "Andrés Riojas", role: "Charla", avatar: "https://i.pravatar.cc/300?u=po", desempeño: 0, tarde: 1, temprano: 0, preceptorias: 1 },
  { id: "3", name: "Mauricio Quintana", role: "Refrigerio", avatar: "https://i.pravatar.cc/300?u=pa", desempeño: 1, tarde: 0, temprano: 1, preceptorias: 4 },
  { id: "4", name: "Luis Hernández", role: "Asistencia", avatar: "https://i.pravatar.cc/300?u=ma", desempeño: 0, tarde: 0, temprano: 0, preceptorias: 3 },
  { id: "5", name: "Mauricio Quintana", role: "Materiales", avatar: "https://i.pravatar.cc/300?u=sa", desempeño: 0, tarde: 1, temprano: 1, preceptorias: 1 },
  { id: "6", name: "Ana Gómez", role: "Cobranza", avatar: "https://i.pravatar.cc/300?u=ta", desempeño: 1, tarde: 0, temprano: 1, preceptorias: 2 },
];

export const NORMAS_CATALOG = [
  { id: 1, icon: <MdChurch />, label: "Visita", description: "Visita al santisimo", color: "blue.500" },
  { id: 2, icon: <MdHandshake />, label: "Meditación", description: "Meditación con el padre", color: "green.500" },
  { id: 3, icon: <MdNotificationsActive />, label: "Angelus", description: "Rezo del Angelus", color: "red.500" },
  { id: 4, icon: <MdOutlineSelfImprovement />, label: "Oración", description: "Oración en el oratorio", color: "orange.500" },
  { id: 5, icon: <MdFlare />, label: "Bendición", description: "Bendición con el Santisimo", color: "yellow.500" },
  { id: 6, icon: <MdCelebration />, label: "Misa", description: "Celebración de la Santa Misa", color: "purple.500" },
];

export const RATING_OPTIONS = [
  { value: 1, label: "Muy Mal" },
  { value: 2, label: "Mal" },
  { value: 3, label: "Puede Mejorar" },
  { value: 4, label: "Bien" },
  { value: 5, label: "Muy Bien" },
];

export const RATING_ITEMS = RATING_OPTIONS.map((o) => ({ label: o.label, value: String(o.value) }));

export function ratingToLabel(n) {
  const opt = RATING_OPTIONS.find((x) => x.value === Number(n));
  return opt ? opt.label : "—";
}
